import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import moment from "moment";
const BASER_URL = '/master'
interface Filter {
    filterField: string;
    filterValue: any;
}

interface FetchLaboursParams {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: Filter[];
}

interface FetchLaboursResponse {
    data: any[];
    rowCount: number;
}

export const fetchAllLabours = createAsyncThunk<
    FetchLaboursResponse,
    FetchLaboursParams
>(
    "labour/fetchAllLabours",
    async ({ page, pageSize, sort, order, search, filters }) => {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("page_size", pageSize.toString());

        if (search) params.append("search", search);
        if (sort) {
            params.append("ordering", order === "desc" ? `-${sort}` : sort);
        }

        filters?.forEach(({ filterField, filterValue }) => {
            if (!filterField || filterValue === undefined || filterValue === null) return;

            // Check if filterValue is an object (e.g., date range)
            if (typeof filterValue === "object" && filterValue !== null) {
                // If it's a date filter
                if (filterValue.from_date || filterValue.to_date) {
                    if (filterField === "created_at") {
                        if (filterValue.from_date)
                            params.append("created_at_from", String(filterValue.from_date));
                        if (filterValue.to_date)
                            params.append("created_at_to", String(filterValue.to_date));
                    } else if (filterField === "updated_at") {
                        if (filterValue.from_date)
                            params.append("updated_at_from", String(filterValue.from_date));
                        if (filterValue.to_date)
                            params.append("updated_at_to", String(filterValue.to_date));
                    }
                } else {
                    // For other object filters
                    Object.entries(filterValue).forEach(([key, value]) => {
                        if (value !== undefined && value !== null && value !== "") {
                            params.append(key, String(value));
                        }
                    });
                }
            } else {
                // Normal simple filters
                params.append(filterField, String(filterValue));
            }
        });


        console.log(params.toString())

        const response = await Axios.get(`${BASER_URL}/labour/?${params.toString()}`);

        return {
            data: response?.data?.data ?? [],
            rowCount: response?.data?.count ?? 0,
        };
    }
);


export const fetchLabourById = createAsyncThunk(
    "labour/fetchLabourById",
    async (id: string, { rejectWithValue }) => {
        try {
            const response: any = await Axios.get(`${BASER_URL}/labour/${id}/get`);
            return response.data.data || response.data;
        } catch (err: any) {
            return rejectWithValue(
                err.response?.data || "Failed to fetch Labour by ID"
            );
        }
    }
);





export const addLabour = createAsyncThunk(
    "labour/addLabour",
    async (formData: FormData, { rejectWithValue }) => {
        try {
            const response: any = await Axios.post(`${BASER_URL}/labour/create/`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (err: any) {
            return rejectWithValue(
                err.response?.data || "Failed to add Labour"
            );
        }
    }
);

export const updateLabour = createAsyncThunk(
    "labour/updateLabour",
    async ({ id, formData }: { id: string; formData: FormData }, { rejectWithValue }) => {
        try {
            const response: any = await Axios.put(`${BASER_URL}/labour/${id}/update`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (err: any) {
            return rejectWithValue(
                err.response?.data || "Failed to update Labour"
            );
        }
    }
);

export const updateStatusInLabour = createAsyncThunk(
    "labour/updateStatusInLabour",
    async (data: { labour_id: string; is_active: boolean }, { rejectWithValue }) => {
        try {
            const response: any = await Axios.patch(`${BASER_URL}/labour/${data.labour_id}/update`, {
                is_active: data.is_active,
            });
            const responseData = response.data?.data || response.data || {};
            // Ensure labour_id and is_active are included in the response
            return {
                ...responseData,
                labour_id: responseData.labour_id || data.labour_id,
                is_active: responseData.is_active !== undefined ? responseData.is_active : data.is_active,
            };
        } catch (err: any) {
            return rejectWithValue(
                err.response?.data || "Failed to update Labour status"
            );
        }
    }
);

export interface LabourExportFilters {
  search?: string;
  created_at_from?: string; // YYYY-MM-DD
  created_at_to?: string;   // YYYY-MM-DD
  is_active?: boolean | string;
  labour_name?: string;
  contact_number?: string;
  pan_number?: string;
  aadhar_number?: string;
  city?: string;
  state?: string;
  country?: string;
  created_by?: string;
  updated_by?: string;
}

/**
 * Convert filters to query params
 */
const buildQueryParams = (filters: LabourExportFilters) => {
  const params: any = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (key === "created_at_from" || key === "created_at_to") {
        params[key] = moment(value).format("YYYY-MM-DD");
      } else {
        params[key] = value;
      }
    }
  });

  return params;
};

/**
 * Download blob as CSV
 */
const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Export Labour CSV
 */
// export const exportLabourCSV = async (filters: LabourExportFilters = {}) => {
//   try {
//     const params = buildQueryParams(filters);
//     params.export = "csv"; // signal backend to return CSV

//     const response = await Axios.get(`/master/labour/export`, {
//       params,
//       responseType: "blob",
//     });

//     const filename = `labours_${moment().format("YYYY-MM-DD")}.csv`;
//     downloadBlob(response.data, filename);
//     return { success: true, message: "CSV downloaded successfully" };
//   } catch (error: any) {
//     console.error("Export failed:", error);
//     return { success: false, message: error.response?.data?.message || error.message || "Failed to export CSV" };
//   }
// };




// Fetch labour dropdown for forms

// import { Axios } from "api/axios"; // your axios instance

export const exportLabourMasterCSV = async ({
  sort,
  order,
  search,
  filters,
}: {
  sort: any;
  order: any;
  search: any;
  filters: any;
}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);

  if (sort) {
    const orderingValue = order === "desc" ? `-${sort}` : sort;
    params.append("ordering", orderingValue);
  }

  if (filters?.length) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null)
          return;

        // Handle date-range filters (object with from_date / to_date)
        if (typeof filterValue === "object" && filterValue !== null) {
          const { from_date, to_date } = filterValue;

          if (
            from_date &&
            (filterField === "created_at" || filterField === "updated_at")
          ) {
            params.append(`${filterField}_from`, from_date);
          }

          if (
            to_date &&
            (filterField === "created_at" || filterField === "updated_at")
          ) {
            params.append(`${filterField}_to`, to_date);
          }
        } else {
          // Simple filters
          params.append(filterField, String(filterValue));
        }
      }
    );
  }

  try {
    const response = await Axios.get(`/master/labour?${params.toString()}`, {
      params: { export: "csv" }, // tell backend to return CSV
      responseType: "blob", // important
    });

    // Download CSV
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "labours.csv"); // file name
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading Labour CSV", error);
    throw error;
  }
};


export const fetchLabourDropdownForForms = createAsyncThunk(
    "labour/fetchLabourDropdownForForms",
    async (_, { rejectWithValue }) => {
        try {
            const response = await Axios.get(`/master/labour/dropdown/`);
            const data = Array.isArray(response.data)
                ? response.data
                : response.data?.data || response.data?.labour_name || [];
            return data;
        } catch (err: any) {
            return rejectWithValue(
                err.response?.data || "Failed to fetch Labour dropdown"
            );
        }
    }
);